import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { JobLogsState, JobsState, JobState } from './states';
import {
  CancelJobsActions,
  CreateJobsActions,
  JobLogsActions,
  JobsActions,
} from './actions';

export const jobsRecipe: Recipe<JobsState, JobsActions> = (draft, action) => {
  switch (action.type) {
    case 'jobs/started':
      draft.pending = true;
      return;

    case 'jobs/finished':
      draft.pending = false;
      draft.jobs = action.jobs;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const jobLogsRecipe: Recipe<JobLogsState, JobLogsActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'jobs/logs/started':
      draft.pending = true;
      return;

    case 'jobs/logs/finished':
      draft.pending = false;
      draft.id = action.id;
      draft.logs = action.logs;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const createJobsRecipe: Recipe<JobsState, CreateJobsActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'jobs/create/started':
      draft.pending = true;
      return;

    case 'jobs/create/finished':
      draft.pending = false;
      draft.jobs = action.jobs;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const cancelJobsRecipe: Recipe<JobState, CancelJobsActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'jobs/cancel/started':
      draft.pending = true;
      return;

    case 'jobs/cancel/finished':
      draft.pending = false;
      draft.job = action.job;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
